var EAffiliateTransactionType = /*#__PURE__*/ function(EAffiliateTransactionType) {
    EAffiliateTransactionType["Sale"] = "sale";
    EAffiliateTransactionType["Refund"] = "refund";
    return EAffiliateTransactionType;
}(EAffiliateTransactionType || {});
var EAffiliateTransactionTrackingMethod = /*#__PURE__*/ function(EAffiliateTransactionTrackingMethod) {
    EAffiliateTransactionTrackingMethod["Link"] = "link";
    EAffiliateTransactionTrackingMethod["Coupon"] = "coupon";
    EAffiliateTransactionTrackingMethod["Support"] = "support";
    return EAffiliateTransactionTrackingMethod;
}(EAffiliateTransactionTrackingMethod || {});
export { EAffiliateTransactionType, EAffiliateTransactionTrackingMethod };
